<img
  class="avatar"
  [src]="
    this.thumbnailUrl ? this.thumbnailUrl : 'assets/icons/empty-avatar.svg'
  "
  [alt]="this.tooltip ? this.tooltip : ''"
  [matTooltip]="this.tooltip ? this.tooltip : ''"
  [matTooltipPosition]="this.tooltipPosition"
/>
